import React from 'react'
import "../hamburger/Burger.css"

const Burger = () => {
  return (
    <>
    <div className="main">
    <div className='burger'>
        <div className="burger-1"></div>
        <div className="burger-1"></div>
        <div className="burger-1"></div>
    </div>



    </div>



    </>
  )
}

export default Burger